// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import type {VNode} from 'snabbdom';

import {ButtonEl} from 'common/components/button';
import {Directions} from 'common/components/drop-menu/types';
import {ProjectSelectorEl} from 'common/widgets/project-selector';

import {CoreBanner} from '../template';
import {DropdownType} from '../types';
import type {DropdownBanner} from './index';

/**
 * Creates the dropdown menu that will be shown when the dropdown button is clicked,
 * based on the given dropdown type. The dropdown is aligned to the given parent and
 * uses the given callback to open or close itself. Returns null when the dropdown type
 * is not recognized.
 */
function Dropdown(
  type: DropdownType,
  positionParent: HTMLElement,
  openMenuCallback: (p: boolean) => void,
  menuItemSelectedCallback: (dropType: DropdownType, ev: Event) => void,
): VNode | null {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (type) {
    case DropdownType.ProjectSelector:
      return (
        <ProjectSelectorEl
          params={{
            direction: Directions.Down,
            offset: 2,
            positionParent,
            searchPlaceholder: `Search`,
            submitCopy: `Create New Project`,
          }}
          on={{
            menuchange: (ev) => openMenuCallback(ev.detail.state === `open`),
            select: (ev) => menuItemSelectedCallback(DropdownType.ProjectSelector, ev),
          }}
        />
      );
    default:
      return null;
  }
}

export function template(this: DropdownBanner) {
  const hasDropdown =
    this.attr(`dropdown`) && DropdownType[DropdownType[this.attr(`dropdown`).dropdownType]] !== undefined;
  const dropdownNode = hasDropdown ? (
    <>
      <ButtonEl
        sel='.cta-button'
        attrs={{
          pressed: this.state.isDropdownOpen,
          theme: this.attr(`dropdown`).theme,
        }}
        on={{click: () => this.helpers.setDropdownOpen(true)}}
      >
        {this.attr(`dropdown`).label}
      </ButtonEl>
      {this.state.isDropdownOpen &&
        Dropdown(
          this.attr(`dropdown`).dropdownType,
          this.el.querySelector(`.cta-button`),
          this.helpers.setDropdownOpen,
          this.helpers.handleMenuItemSelected,
        )}
    </>
  ) : null;
  return CoreBanner(this, dropdownNode);
}
